var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1H8V2H9V1ZM1.99994 2.00001H4.99994V3.00001H1.99994V10H8.99997V7.00001H9.99997V11H9.99994V11H0.999939V11V10V3.00001V2.00001H1.99994ZM4.00003 5.99998H3.00003V8.00001V8.99998V9.00001H6.00003V8.00001L6.99994 8.00001V7.00001H5.99994V8.00001L4.00003 8.00001V5.99998ZM5.99997 5.00001H5V5.99997H4V4.99997H4.99997V4.00001H5.99994V3.00001H6.99994V4.00001H5.99997V5.00001ZM7.00006 2.00001H8.00006V3.00001H7.00006V2.00001ZM8.99997 2.00001H9.99997V3.00001H10.9999V4.00001H9.99997V5.00001H9V5.99997H8V4.99997H8.99997V4.00001H9.99994V3.00001H8.99997V2.00001ZM7.00006 5.99998H8.00006V6.99998H7.00006V5.99998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditS);
export default __webpack_public_path__ + "static/media/edit-s.64c5ed75cf6fffd12e4b3849405033ed.svg";
export { ForwardRef as ReactComponent };